import React from 'react';
import { 
  EnvelopeIcon, 
  PhoneIcon, 
  MapPinIcon
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import './ContactInfo.css';

const ContactInfo: React.FC = () => {
  const { t } = useTranslation();
  
  const contactDetails = [
    {
      icon: <PhoneIcon className="contact-icon" />,
      text: '0559547509',
      link: 'tel:+972559547509'
    },
    {
      icon: <EnvelopeIcon className="contact-icon" />,
      text: 'info@protix.co.il',
      link: 'mailto:info@protix.co.il'
    },
    {
      icon: <MapPinIcon className="contact-icon" />,
      text: t('footer.contact.address'),
      link: '#'
    }
  ];

  return (
    <div className="contact-info">
      <h4 className="contact-title">{t('footer.contact.title')}</h4>
      <div className="contact-details">
        {contactDetails.map((contact, index) => (
          <a 
            key={index} 
            href={contact.link}
            className="contact-item"
          >
            {contact.icon}
            <span className="contact-text">{contact.text}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;
